import { render, staticRenderFns } from "./goodsDsCreate.vue?vue&type=template&id=477db2d8&scoped=true"
import script from "./goodsDsCreate.vue?vue&type=script&lang=js"
export * from "./goodsDsCreate.vue?vue&type=script&lang=js"
import style0 from "./goodsDsCreate.vue?vue&type=style&index=0&id=477db2d8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "477db2d8",
  null
  
)

export default component.exports